// Admin › Klinik Detay › WhatsApp kartı — kliniğin Meta hesabındaki Pupill şablonları.
// Klinik de aynı listeyi görür (ClinicManagement/WhatsAppTab/ConnectedPanel).

import React from "react";
import { Box, Typography } from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { ActionButton } from "../../../components/atoms";
import { StatusPill } from "../../../components/organisms/ClinicRecordList";
import { COLORS, TYPO, CARD_PAD } from "../../../styles/uiConstants";
import { MARKETING_NOTE, isMarketing, isSendable, sortTemplates, templateLabel, templateStatusInfo } from "../../../constants/whatsapp";

function TemplateRow({ template, last, palette }) {
  const marketing = isMarketing(template);
  const info = marketing ? { label: "Pazarlama", tone: "error" } : templateStatusInfo(template.status);
  // Reddedilen ya da oluşturulamayan şablonda Meta'nın verdiği sebep gösterilir.
  const failed = ["REJECTED", "NOT_CREATED"].includes(String(template.status || "").toUpperCase());
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: CARD_PAD,
        py: 1,
        minHeight: 44,
        borderBottom: last ? "none" : `1px solid ${COLORS.slate100}`,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: TYPO.body, color: COLORS.slate800 }}>{templateLabel(template)}</Typography>
        {marketing ? (
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.errorDark, mt: 0.25 }}>{MARKETING_NOTE}</Typography>
        ) : null}
        {failed && template.rejectedReason ? (
          <Typography sx={{ fontSize: TYPO.caption, color: COLORS.errorDark, mt: 0.25 }}>
            {template.rejectedReason}
          </Typography>
        ) : null}
      </Box>
      <StatusPill label={info.label} tone={info.tone} palette={palette} />
    </Box>
  );
}

/**
 * @param {Array} templates - AccountView.templates
 * @param {boolean} canSync - admin: admin-clinics:whatsapp, klinik: whatsapp:manage
 * @param {() => void} onSync
 * @param {boolean} syncing
 * @param {object} palette
 */
export default function WhatsAppTemplateList({ templates, canSync, onSync, syncing, palette }) {
  const list = sortTemplates(templates);
  const approved = list.filter(isSendable).length;
  return (
    <Box sx={{ borderTop: `1px solid ${COLORS.slate100}` }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, px: CARD_PAD, py: 1.25 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: TYPO.body, color: COLORS.slate800 }}>Mesaj şablonları</Typography>
          <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500 }}>
            {list.length ? `${approved}/${list.length} onaylı` : "Henüz oluşturulmadı"}
          </Typography>
        </Box>
        {canSync ? (
          <ActionButton
            variant="edit"
            compact
            tone="outline"
            label="Yenile"
            icon={<RefreshIcon sx={{ fontSize: 15 }} />}
            loading={syncing}
            onClick={onSync}
            palette={palette}
          />
        ) : null}
      </Box>
      {list.map((t, i) => (
        <TemplateRow key={t.key || t.name || i} template={t} last={i === list.length - 1} palette={palette} />
      ))}
    </Box>
  );
}
